export default __webpack_public_path__ + "static/media/download.229d171d.svg";